<div class="login_class">

    <ng-container *ngIf="loginType==3">
        <div class="closebutton pointer">
            <img (click)="clickcloseDialog();">
        </div>
        <div class='px-20 t-l text-center '>
            <div class='strong f16 t-c'>Save Opportunity</div>
            <div class='m-t-20'><a class='linkBlue' (click)="loginType=1">Log In</a> to Songdew to bookmark
                this opportunity.</div>
            <div class='m-t-20 pb-5'>Don't have one yet? <a class='linkBlue' (click)="loginType=2">Sign up</a> for Free
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="loginType!=3">

        <div class="mpadding">
            <div class="closebutton pointer">
                <img (click)="clickcloseDialog(); ">
            </div>

            <div class="navbar_login" style="display:flex;">
                <div class="navlogin" style="flex:50%;margin-left:30px">
                    <a [class.active]="loginType==1" (click)="activateLogin()">Login</a>
                    <ng-container *ngIf="loginType==1">
                        <div id="navhighlight1"></div>
                    </ng-container>
                </div>
                <div class="navreg" style="flex:50%;text-align:right;margin-right:16px;">
                    <a [class.active]="loginType==2" (click)="activateRegister()">Register</a>
                    <ng-container *ngIf="loginType==2">
                        <div id="navhighlight2"></div>
                    </ng-container>
                </div>
            </div>
            <hr>
            <div class="loginwith">
                <button *ngIf="!global.isInstagram && !global.isFacebook" type="button" class="fblogin"
                    (click)="global.ga4Event((loginType==1) ? 'login' : 'registration', 'first_form','','facebook', data.userLastClickFrom); signInWithFB()">
                    <img src="../../../assets/images/Facebook.png">{{(loginType==1) ? 'Login' : 'Join'}}
                    with Facebook
                </button>



                <br>
                <button *ngIf="!global.isInstagram && !global.isFacebook" type="button" class="glogin"
                    (click)="global.ga4Event((loginType==1) ? 'login' : 'registration', 'first_form','', 'google', data.userLastClickFrom); signInWithGoogle()">
                    <img src="../../../assets/images/Google.png">{{(loginType==1) ? 'Login' : 'Join'}} with
                    Google
                </button>


            </div>

            <ng-container *ngIf="loginType==1; else register">
                <form id='loginForm' [formGroup]="loginForm" (ngSubmit)="onLoginFormSubmit()">
                    <div class="elogin">
                        <div class="etext" *ngIf="!global.isInstagram && !global.isFacebook">or use your email address
                        </div>
                        <div class="etext2" *ngIf="global.isInstagram || global.isFacebook">Enter your Email Address
                        </div>
                        <div class="useremail">
                            <div class="form-group">
                                <input type="text" formControlName="email" placeholder="Your Email"
                                    [ngClass]="{ 'is-invalid': Loginsubmitted && email.errors }" />
                                <div *ngIf="Loginsubmitted && email.errors" class="invalid-feedback">
                                    <div *ngIf="email.errors?.required"> Please enter your Email Address</div>
                                    <div *ngIf="email.errors?.pattern">
                                        Please enter a valid email ID</div>
                                </div>
                            </div>
                        </div>


                        <div class="userpw">

                            <input [type]="pwdHide ? 'password' : 'text'" placeholder="Password" formControlName="pwd"
                                [ngClass]="{ 'is-invalid': Loginsubmitted && pwd.errors }" required>
                            <span (click)="toggle()" class="field-icon">
                                <img src="assets/image/show.svg" *ngIf="!pwdHide">
                                <img width="20px" src="assets/image/dont-show.png" *ngIf="pwdHide">
                            </span>

                            <div *ngIf="Loginsubmitted && pwd.errors" class="invalid-feedback">

                                <div *ngIf="pwd.errors?.required">
                                    Please enter your password.
                                </div>
                                <div *ngIf="pwd.errors?.minlength && !pwd.errors?.required">
                                    Password must be atleast 6 characters long.
                                </div>
                                <div *ngIf="pwd.errors?.maxlength && !pwd.errors?.required">
                                    Password can't be more than 20 characters long.
                                </div>
                            </div>
                        </div>
                        <div class="error" *ngIf="loginError" style=" margin-bottom: 15px;
"><span class="error">Your email and/or password do not match<br />New to Songdew?</span> <a class="pointer"
                                style="margin-left: 5px;" (click)="activateRegister()"><span
                                    style="color: #FF5F1B;text-decoration:underline;">Create your
                                    account</span></a><br /></div>

                        <div class="forgot bluetext"><a class="pointer boldOnHover" routerLink="/forgot-password"
                                (click)="clickcloseDialog()">Forgot your
                                password?</a></div>
                    </div>
                    <div class="loginbutton">
                        <button type="submit" class="submitbutton m-t-20"
                            (click)="global.ga4Event( 'login', 'first_form','','manual', data.userLastClickFrom)" type='submit'>Login</button>
                    </div>
                    <div class="regmsg">
                        Don't have an account yet? <a class="pointer boldOnHover" (click)="activateRegister()">Sign
                            up</a>
                    </div>
                </form>
            </ng-container>

            <ng-template #register>
                <form id='registerForm' [formGroup]="registerForm" (ngSubmit)="onRegisterFormSubmit()">
                    <div class="elogin">
                        <div class="etext" *ngIf="!global.isInstagram && !global.isFacebook">or use your email address
                        </div>
                        <div class="etext2" *ngIf="global.isInstagram || global.isFacebook">Enter your Email Address
                        </div>
                        <div class="useremail">
                            <div class="form-group">
                                <input id='emailR' (keyup)="resetEmailErrors()" type='email' placeholder="Your Email"
                                    [ngClass]="{ 'is-invalid': Registersubmitted && emailR.errors }"
                                    formControlName="emailR" required [(ngModel)]="emailPopup">
                                <div *ngIf="Registersubmitted && emailR.errors" class="invalid-feedback">
                                    <div *ngIf="emailR.errors?.required">
                                        Please enter your Email Address
                                    </div>
                                    <div *ngIf="!emailR.errors?.required && emailR.dirty && emailR.errors?.email">
                                        Please enter a valid email ID
                                    </div>
                                    <div
                                        *ngIf="!emailR.errors?.required && emailR.dirty && !emailR.errors?.email && emailR.errors?.pattern">
                                        Please enter a valid email ID
                                    </div>
                                    <div
                                        *ngIf="!emailR.errors?.required && emailR.dirty && !emailR.errors?.email && !emailR.errors?.pattern && emailR.errors?.emailExists">
                                        The email ID entered already exist
                                    </div>
                                    <div>
                                        <div *ngIf="!emailR.errors?.required && emailR.dirty && !emailR.errors?.email && !emailR.errors?.pattern && emailR.errors?.invalidEmail">
                                          Invalid Email Address
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="userpw">
                            <div class="form-group">
                                <input [type]="pwdHide ? 'password' : 'text'" placeholder="Password"
                                    [ngClass]="{ 'is-invalid': Registersubmitted && pwdR.errors }"
                                    formControlName="pwdR" required>
                                <span (click)="toggle()" class="field-icon">
                                    <img src="assets/image/show.svg" *ngIf="!pwdHide">
                                    <img width="20px" src="assets/image/dont-show.png" *ngIf="pwdHide">
                                </span>
                                <div *ngIf="Registersubmitted && pwdR.errors" class="invalid-feedback">

                                    <div *ngIf="pwdR.errors?.required">
                                        Please enter a password
                                    </div>
                                    <div *ngIf="pwdR.errors?.minlength && !pwdR.errors?.required">
                                        Password must be atleast 6 characters long
                                    </div>
                                    <div *ngIf="pwdR.errors?.maxlength && !pwdR.errors?.required">
                                        Password can't be more than 20 characters long
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="registerError">{{registerErrorMsg}}</div>
                    </div>
                    <div class="loginbutton">
                        <button type="submit" class="submitbutton m-t-20"
                            (click)="global.ga4Event( 'registration', 'first_form','', 'manual', data.userLastClickFrom)">Submit</button>
                    </div>
                    <div class="regmsg">
                        Already have an account? <a class="pointer boldOnHover" (click)="activateLogin()">Login</a>
                    </div>
                </form>
            </ng-template>

            <div class='p-20'>
            </div>

        </div>
    </ng-container>
</div>